import type { ReactNode } from 'react';
import type { ProductNameLine } from 'autogen/swagger/all';
import { Brand, Miscellaneous, Product, Variant } from '../shared/styles';
import { ProductNameLineTheme } from '../shared/theme';
import type { IProductName, IProductNameSize } from '../shared/types';

const standardProductNameRenderer = (
    line: ProductNameLine,
    strongProductTitle: IProductName['strongProductTitle'],
    size: IProductNameSize = 'md',
    as?: IProductName['as']
): JSX.Element | ReactNode => {
    const { type, url, value } = line;

    switch (type) {
        case 'Brand':
            return (
                <Brand
                    size={ProductNameLineTheme[size].Brand}
                    forwardedAs={as || (url ? 'a' : 'span')}
                    key={type}
                    href={url}
                >
                    {value}
                </Brand>
            );

        case 'Name':
            return (
                <Product
                    size={ProductNameLineTheme[size].Name}
                    strong={strongProductTitle}
                    forwardedAs={as || (url ? 'a' : 'span')}
                    key={type}
                    href={url}
                >
                    {value}
                </Product>
            );
        case 'Size':
        case 'Color':
        case 'Variant':
            return (
                <Variant size={ProductNameLineTheme[size].Variant} forwardedAs="span" key={type}>
                    {value}
                </Variant>
            );

        default:
            return (
                <Miscellaneous forwardedAs="span" size={ProductNameLineTheme[size].Variant} key={type}>
                    {value}
                </Miscellaneous>
            );
    }
};

export default standardProductNameRenderer;
